import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d667657"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "link-tile-grid-container" }
const _hoisted_2 = {
  key: 0,
  class: "link-tile-grid-title"
}
const _hoisted_3 = { class: "link-tile-grid-tiles" }

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { scrollToTop } from '@/helpers/helpers';
import { LinkDataInternal } from '@/models/data';

export default /*#__PURE__*/_defineComponent({
  __name: 'LinkTileGrid',
  props: {
    title: null,
    cols: null
  },
  setup(__props: any) {

const props = __props as {
  title?: string,
  cols: number
}

_useCssVars(_ctx => ({
  "18a369dc": (__props.cols)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})